import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeRoute from "../features/home/routes";
import PromotionRoutes from "../features/promotion/routes";
import CMSPage from "../features/cms/components/CMSPage";
import { MainLayout, AuthLayout } from "../components/layouts";
import { AuthRoutes } from "../features/auth";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import UserRoutes from "../features/users/routes";
import GameRoutes from "../features/games/routes";
import { UserVerification } from "../features/users/components/user-verification/UserVerification";
import { ResetPassword } from "../features/users/components/resetPassword/ResetPassword";
import { DeviceType } from "../models/constants/deviceType";
import userDeviceStore from "../store/device.store";
import Maintenance from "../features/maintenance/components/Maintenance";
import ScrollToTop from "../hooks/ScrollToTop";
import AndroidApp from "../features/android-app/Components/AndroidApp";

export default function AppRoutes() {

  const deviceType = userDeviceStore((state) => state.deviceType);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route element={<PublicRoute />}>
            <Route path="android-app" element={<AndroidApp />} />
            <Route path="android-app/scan" element={<AndroidApp />} />
            <Route index element={<HomeRoute />} />
            <Route path="promotion/*" element={<PromotionRoutes />} />
            {GameRoutes()}
          </Route>

          <Route element={<ProtectedRoute />}>
            {UserRoutes()}
            {GameRoutes()}
            <Route path="reset-password" element={<ResetPassword />} />
          </Route>

          <Route path=":pageKey" element={<CMSPage />} />
        </Route>

        <Route element={deviceType === DeviceType.Mobile ? <AuthLayout /> : <MainLayout />}>
          <Route element={<PublicRoute />}>{AuthRoutes()}</Route>
        </Route>

        <Route element={<AuthLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="user-verification" element={<UserVerification />} />
          </Route>
          <Route element={<PublicRoute />}>
            <Route path="maintenance" element={<Maintenance />} />
          </Route>
        </Route>

      </Routes>
    </Router>
  );
}
